import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, NgForm } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { IInduccionResultadosModel } from 'src/app/models/interfaces/induccion/IInduccionResultadoModel';
import { ISeguridadUsuarioResultadoBusquedaModel } from 'src/app/models/interfaces/seguridad/ISeguridadUsuarioResultadoBusquedaModel';
import { InduccionService } from 'src/app/services/induccion/induccion.service';
import { Observable } from 'rxjs';
import { filter, map, startWith, switchMap } from 'rxjs/operators';
import { FilterUsuarioModel } from 'src/app/models/seguridad/FilterUsuarioModel';
import { UsuarioService } from 'src/app/services/seguridad/usuario/usuario.service';
import { TipoUsuario } from 'src/app/models/common/enumModel';
import { ConfirmDialogService } from 'src/app/services/confirm-dialog/confirm-dialog.service';

@Component({
  selector: 'app-induccion-resultados-dialog',
  templateUrl: './induccion-resultados-dialog.component.html',
  styleUrls: ['./induccion-resultados-dialog.component.css']
})
export class InduccionResultadosDialogComponent implements OnInit {
  myControl = new FormControl();
  existeEmpleado: boolean = false;
  filteredOptions!: Observable<ISeguridadUsuarioResultadoBusquedaModel[]>;
  constructor(
    public dialogRef: MatDialogRef<InduccionResultadosDialogComponent>,
    private induccionService: InduccionService,
    private seguridadUsuarioService: UsuarioService,
    private confirmDialogService: ConfirmDialogService,
    @Inject(MAT_DIALOG_DATA) public model: IInduccionResultadosModel
  ) { }

  ngOnInit(): void {
    this.filteredOptions = this.myControl.valueChanges.pipe(
      startWith(''),
      filter(x => typeof x != 'string' || x.length>2),
      switchMap(value => this._filterUsuarios(value))
    ); 
  }

  onNoClick(): void {
    this.dialogRef.close(false);
  }  

  Save(): void{
    // if (!form.invalid) {      
      console.log(this.model);
      // this.induccionService.registrarResultados(this.model).subscribe(p => {
      //   // console.log(p);
      //   this.dialogRef.close();
      // });  
    // }
    this.confirmDialogService.open('¿Deseas guardar los cambios?'); //options
    this.confirmDialogService.confirmed().subscribe((confirmed) => {
      if (confirmed) {
        this.induccionService.registrarResultados(this.model).subscribe((data) => {
          // console.log(data);
          this.dialogRef.close(true);
        });
      }
    });
  }


  onSubmit(form: NgForm) {
    // console.log(this.data.persona.documentos);
    if (!form.invalid) {      
      this.induccionService.registrarResultados(this.model).subscribe(p => {
        // console.log(p);
        this.dialogRef.close(true);
      });  
    }
  }

  verificarUsuario(event: any){
    // console.log(event);
    if(event.option.value.email !== ''){
      // this.model.gidCapacitador = event.option.value.email;
      // this.model.nombresCapacitador = `${event.option.value.firstName} ${event.option.value.lastName}`;
      // this.usuarioService.verificarSiExiste(event.option.value.email).subscribe((data) => {
      //   // console.log(data);
         this.existeEmpleado = true;
      // });
    }
  }
  displayFn(memberid: ISeguridadUsuarioResultadoBusquedaModel): string
  {
    if(memberid){
      return `${memberid.firstName} ${memberid.lastName} - ${memberid.email}`; //`${memberid.email}`;
    }
    else {
      return '';
    }
  }

  private _filterUsuarios(value: string) {
    const usuariosFilter = new FilterUsuarioModel();
    usuariosFilter.idTipoUsuario = TipoUsuario.Empleado;

    if(typeof value == 'string'){
      usuariosFilter.correo = value.toString().toLowerCase();      
      this.existeEmpleado = false;
      this.model.gidCapacitador = '';
      this.model.nombresCapacitador = '';
    }
    else {
      const usuario = (value as ISeguridadUsuarioResultadoBusquedaModel);
      usuariosFilter.correo = '';
      usuariosFilter.idUsuarios.push(usuario.id);

      this.model.gidCapacitador = usuario.email;
      this.model.nombresCapacitador = `${usuario.firstName} ${usuario.lastName}`;
    }
    
    return this.seguridadUsuarioService.getList(usuariosFilter).pipe(
      filter(data => !!data),
      map((data) => {
        return data.items.filter(option => (`${option.firstName} ${option.lastName} ${option.email}`).toLocaleLowerCase().includes(value.toString().toLowerCase()))
      })
    );
  }
}
